import { render, staticRenderFns } from "./BroadcastCalls.vue?vue&type=template&id=13087724&"
import script from "./BroadcastCalls.vue?vue&type=script&lang=js&"
export * from "./BroadcastCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports